module.exports = __webpack_public_path__ + "static/media/IMG_1818-minJPG.cfe16939.jpg";